// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import translate from "@insite/client-framework/Translate";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { pluralize } from "@sc/XDL/Utilities";
import React from "react";

export interface PageTitleCountStyles {
    container?: InjectableCss;
    pageTitle?: TypographyProps;
    productCountText?: TypographyProps;
}

type Props = {
    countNumber: number;
    countName: string;
    pageTitleOverride?: string;
    showPageTitle?: boolean;
};

export const pageTitleCountStyles: PageTitleCountStyles = {};

const styles = pageTitleCountStyles;
const PageTitleCount = ({ pageTitleOverride, countNumber, countName, showPageTitle = true }: Props) => {
    const pageTitle = useAppSelector(state => getCurrentPage(state).fields.title);

    return (
        <StyledWrapper {...styles.container}>
            {!!pageTitle && showPageTitle && (
                <Typography {...styles.pageTitle}>{translate(pageTitle || pageTitleOverride)}</Typography>
            )}
            {!!countNumber && !!countName && (
                <Typography className="product-count-wrapper" {...styles.productCountText}>
                    {pluralize(countNumber, translate(countName), {
                        showNumber: true,
                    })}
                </Typography>
            )}
        </StyledWrapper>
    );
};

export default PageTitleCount;
